import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import {
  DataTableModule, SharedModule, ButtonModule, GrowlModule, InputTextModule,
  ConfirmDialogModule, DataGridModule, PanelModule, TabViewModule, InputSwitchModule, 
  DropdownModule, StepsModule, ProgressBarModule, ChartModule, SliderModule
} from 'primeng/primeng';

import { LocationRoutingModule } from './location-routing.module';
import { AreaComponent } from '../area/area.component';
import { AreaService } from './area.service';
import { LocationComponent } from './location.component';
import { LocationService } from './location.service';
import { LocationGeneratorComponent } from '../location-generator/location-generator.component';
import { LocationTypeComponent } from '../location-type/location-type.component';
import { LocationTypeService } from './location-type.service';
import { LocationLogicService } from './location-logic.service';
import { BinTypeService } from './bin-type.service';
import { BinService } from './bin.service';
import { BinTypeComponent } from '../bin-type/bin-type.component';
import { LocationSearchService } from './location-search.service';
import { LocationSearchComponent } from '../location-search/location-search.component';

@NgModule({
  imports: [
    CommonModule,
    LocationRoutingModule,
    FormsModule,
    DataTableModule, SharedModule,
    ButtonModule, GrowlModule, InputTextModule, ConfirmDialogModule,
    DataGridModule, PanelModule, TabViewModule, InputSwitchModule,
    DropdownModule, StepsModule, ProgressBarModule, ChartModule, SliderModule
  ],
  declarations: [
    AreaComponent, LocationComponent,
    LocationGeneratorComponent, LocationTypeComponent, BinTypeComponent, LocationSearchComponent
  ],
  exports : [
    LocationSearchComponent
  ],
  providers: [AreaService, LocationService, LocationTypeService, LocationLogicService, BinTypeService, BinService, LocationSearchService]
})
export class LocationModule { }



// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/location/location.module.ts